var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header home-header" }, [
      _c("a", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "back",
        attrs: { href: "javascript:void(0)" },
        on: { click: _vm.goBack }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm.showFlag && _vm.loginFlag
        ? _c("div", { staticClass: "btn", on: { click: _vm.switchFlag } }, [
            _c("a", {
              staticClass: "dot",
              class: _vm.showCircle && _vm.isShowDot ? "new" : "",
              attrs: { href: "javascript:void(0)" }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "right-action-wrap" }, [_vm._t("action")], 2),
      _vm._v(" "),
      _vm.flag
        ? _c("div", { staticClass: "toggle_box" }, [
            _c("img", {
              staticClass: "top",
              attrs: {
                src: require("../../styles/common/img/toggle_box_top.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "toggle_box_con" }, [
              _vm.isHome
                ? _c("a", {
                    staticClass: "home",
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        return _vm.navigateTo("/home")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isMine
                ? _c("a", {
                    staticClass: "mine",
                    class: _vm.showCircle ? "new" : "",
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        return _vm.navigateTo("/myCenter")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isCart
                ? _c("a", {
                    staticClass: "shoppingCart",
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        return _vm.navigateTo("/shoppingCar")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isService
                ? _c("a", {
                    staticClass: "server",
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.toService }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "bottom",
              attrs: {
                src: require("../../styles/common/img/toggle_box_bottom.png"),
                alt: ""
              }
            })
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    !_vm.isShow ? _c("div", { staticClass: "header-seat" }) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2282682b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2282682b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/header.vue
// module id = null
// module chunks = 